module.exports = __webpack_public_path__ + "static/media/goop.c6cc240f.jpg";